import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Chip } from '@mui/material';
import { CheckCircle2, X } from 'lucide-react';
import styles from './GateRequestSuccessModal.module.css';
import successCheck from 'assets/images/successCheck.svg';
import { safeToAmPm } from './GatePassRequestTable';
export const typeResolve = (rawType) => {
  if (!rawType) return '';
  if (rawType.toLowerCase() === 'leave') return 'Leave';
  if (rawType.toLowerCase() === 'early_departure' || rawType.toLowerCase() === 'early departure') return 'Early Departure';
  if (rawType.toLowerCase() === 'late_entry' || rawType.toLowerCase() === 'late entry') return 'Late Entry';
  return '';
};

const GateRequestSuccessModal = ({ open, onClose, onDashboard, data }) => {
  if (!open) return null;
  // console.log('successdata', data);

  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return '—';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatDateRange = (value) => {
    if (!value) return 'Not Available (N/A)';

    if (!value.includes('to')) {
      return formatDateDDMMYYYY(value);
    }

    const [start, end] = value.split(' to ').map((v) => v.trim());
    return `${formatDateDDMMYYYY(start)} to ${formatDateDDMMYYYY(end)}`;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'in progress':
        return { bg: '#F3E8FF', text: '#9333EA', border: '#F3E8FF' };
      case 'resolved':
        return { bg: '#DCFCE7', text: '#16A34A', border: '#DCFCE7' };
      case 'pending':
        return { bg: '#FEF9C3', text: '#CA8A04', border: '#FEF9C3' };
      case 'rejected':
        return { bg: '#FEE2E2', text: '#DC2626', border: '#FEE2E2' };
      default:
        return { bg: '#f3f4f6', text: '#6b7280', border: '#d1d5db' };
    }
  };

  // Example

  const normalizeStatus = (rawStatus) => {
    if (!rawStatus) return 'pending';
    const s = String(rawStatus).toLowerCase().trim();
    if (s === 'in_progress' || s === 'in-progress') return 'in progress';
    if (s === 'open') return 'pending';
    if (s === 'pending' || s === 'resolved' || s === 'rejected' || s === 'in progress') return s;
    return s; // fall back to whatever came, will hit default colors if unknown
  };

  const { requestId, status = 'pending', requestType, date, fromTime, toTime, reason } = data || {};
  const normalizedStatus = normalizeStatus(status);
  const chipColors = getStatusColor(normalizedStatus);
  return ReactDOM.createPortal(
    <div className={styles.backdrop}>
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.header}>
          <h3 className={styles.title}>Submit New Gate Pass Request</h3>
          <button className={styles.iconBtn} onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.centerBlock}>
            <div className={styles.successIcon}>
              {/* <CheckCircle2 size={28} /> */}
              <img src={successCheck} alt="success" />
            </div>
            <h4 className={styles.successTitle}>Request Submitted Successfully!</h4>
            <p className={styles.successSub}>Your gate pass request has been submitted for approval.</p>
          </div>

          <div className={styles.detailsGrid}>
            <div>
              <p className={styles.label}>Request ID</p>
              <p className={styles.value}>{requestId || '—'}</p>
            </div>
            <div>
              <p className={styles.label}>Status</p>
              <Chip
                label={normalizedStatus}
                size="small"
                sx={{
                  bgcolor: chipColors.bg,
                  color: chipColors.text,
                  border: `1px solid ${chipColors.border}`,
                  height: 24,
                  '& .MuiChip-label': { px: 1 }
                }}
              />
            </div>
            <div>
              <p className={styles.label}>Request Type</p>
              <p className={styles.value} style={{ fontWeight: 500, textTransform: 'capitalize' }}>
                {requestType ? typeResolve(requestType) : 'Not Available (N/A)'}
              </p>
            </div>
            {requestType === 'leave' ? (
              <div>
                <p className={styles.label}>Duration</p>
                <p className={styles.value} style={{ fontWeight: 500 }}>
                  {formatDateRange(date)}
                </p>
              </div>
            ) : (
              <div>
                <p className={styles.label}>Duration</p>
                <p className={styles.value} style={{ fontWeight: 500 }}>
                  {date ? formatDateDDMMYYYY(date) : 'Not Available (N/A)'} {toTime ? ` ${safeToAmPm(toTime)}` : ''}
                </p>
              </div>
            )}

            <div className={styles.reasonBlock}>
              <p className={styles.label}>Reason</p>
              <p className={styles.value}>{reason || 'Please provide a detailed reason for your request..' || '—'}</p>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <Button variant="outlined" onClick={onClose} className={styles.cancelBtn}>
            Close
          </Button>
          <Button variant="contained" onClick={onDashboard} className={styles.primaryBtn}>
            Main Dashboard
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default GateRequestSuccessModal;
